import { Container, Group, Text, Anchor, Divider, Box } from "@mantine/core";
// @ts-ignore
const CURRENT_YEAR = new Date().getFullYear();
import { IconBrandX, IconBrandTelegram } from "@tabler/icons-react";
import { Link } from "gatsby";
import React from "react";

const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Projects", to: "/projects/" },
  { label: "HUB", to: "/hub/" },
  { label: "Blog", to: "/blog/" },
  { label: "YD", to: "/yd/" },
];

const Footer: React.FC = () => (
  <Box
    component="footer"
    style={{
      marginTop: 60,
      borderTop: "1px solid rgba(153, 69, 255, 0.18)",
      background: "rgba(255,255,255,0.015)",
      paddingTop: 40,
    }}
  >
    <Container size="lg" px="md">
      <Group justify="space-between" align="flex-start" wrap="wrap" gap={32} mb={32}>
        {/* Logo + tagline */}
        <Box style={{ maxWidth: 280 }}>
          <Text
            fw={900}
            style={{
              background: "linear-gradient(45deg, #9945FF, #14F195)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontSize: "1.5rem",
              letterSpacing: "-0.5px",
            }}
          >
            Y-DAO
          </Text>
          <Text size="xs" c="dimmed" mt={6} style={{ lineHeight: 1.5 }}>
            A founder-led, coordinated collective building products, dealflow, and network on Solana.
          </Text>
        </Box>

        {/* Nav */}
        <Group gap="lg" wrap="wrap" justify="center">
          {NAV_LINKS.map((link) => (
            <Anchor
              key={link.label}
              component={Link}
              to={link.to}
              style={{ color: "var(--mantine-color-dimmed)", fontSize: 14, textDecoration: "none" }}
            >
              {link.label}
            </Anchor>
          ))}
        </Group>

        {/* Social */}
        <Group gap={12}>
          <Anchor
            href="https://x.com/CryptoYDao"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "var(--mantine-color-dimmed)", display: "flex", alignItems: "center" }}
          >
            <IconBrandX size={22} stroke={1.5} />
          </Anchor>
          <Anchor
            href="https://t.me/YegorDO"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "var(--mantine-color-dimmed)", display: "flex", alignItems: "center" }}
          >
            <IconBrandTelegram size={22} stroke={1.5} />
          </Anchor>
        </Group>
      </Group>

      <Divider style={{ borderColor: "rgba(153, 69, 255, 0.1)" }} />

      <Text ta="center" size="xs" c="dimmed" py={20} style={{ fontFamily: "IBM Plex Mono, monospace" }}>
        © {CURRENT_YEAR} Y-DAO. Built on Solana.{" "}
        <Anchor
          component={Link}
          to="/manifesto/"
          style={{ color: "var(--mantine-color-dimmed)", textDecoration: "none" }}
        >
          Manifesto →
        </Anchor>
      </Text>
    </Container>
  </Box>
);

export default Footer;
